import { LinearValueBar, ProgressWrapper } from './style';
import { LinearProgressProps } from './types';

const calculateRatio = ({ max, min, value }: { max: number; min: number; value: number }) => {
    if (value < min) {
        return 0;
    }
    if (value > max) {
        return 1;
    }

    return (value - min) / (max - min);
};

export const LinearProgress = ({
    mode,
    max = 100,
    min = 0,
    value = 0,
    variant,
    disabled,
    ...other
}: LinearProgressProps) => {
    const ratio = calculateRatio({ max, min, value });

    return (
        <ProgressWrapper aria-valuenow={value} aria-valuemin={min} aria-valuemax={max} {...other}>
            <LinearValueBar disabled={disabled} mode={mode} variant={variant} scale={ratio} />
        </ProgressWrapper>
    );
};
